var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment_failed",
    transform: "translate(-912 -276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit_score_black_24dp_1_",
    "data-name": "credit_score_black_24dp (1)",
    transform: "translate(912 276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7070",
    "data-name": "Group 7070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46979",
    "data-name": "Path 46979",
    d: "M0,0H160V160H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7071",
    "data-name": "Group 7071",
    transform: "translate(13.333 26.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46980",
    "data-name": "Path 46980",
    d: "M122,4H15.333A13.231,13.231,0,0,0,2.067,17.333L2,97.333a13.287,13.287,0,0,0,13.333,13.333H42A6.686,6.686,0,0,0,48.667,104h0A6.686,6.686,0,0,0,42,97.333H15.333v-40h120v-40A13.373,13.373,0,0,0,122,4Zm0,26.667H15.333V17.333H122Z",
    transform: "translate(-2 -4)",
    fill: "#f64f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M2188.9,3126.254a6.629,6.629,0,0,1-4.74-1.948l-14.07-14.042-14.07,14.042a6.628,6.628,0,0,1-4.755,1.948,6.787,6.787,0,0,1-4.839-1.837,5.086,5.086,0,0,1-1.732-4.257,6.632,6.632,0,0,1,1.927-5.257l2.2-2.2c.661-.758,1.414-1.562,2.27-2.418l9.508-9.49-9.508-9.489c-.858-.858-1.612-1.664-2.274-2.423l-2.2-2.2a6.629,6.629,0,0,1-1.927-5.256,5.087,5.087,0,0,1,1.732-4.257,6.79,6.79,0,0,1,4.834-1.836,6.627,6.627,0,0,1,4.76,1.949l14.07,14.042,14.07-14.042a6.628,6.628,0,0,1,4.771-1.949H2189a6.773,6.773,0,0,1,4.748,1.837,5.087,5.087,0,0,1,1.733,4.256,6.631,6.631,0,0,1-1.927,5.258l-2.2,2.2c-.661.758-1.414,1.562-2.27,2.418l-9.508,9.49,9.508,9.489c.854.854,1.606,1.657,2.265,2.413l2.208,2.208a6.632,6.632,0,0,1,1.927,5.258,5.086,5.086,0,0,1-1.733,4.255,6.771,6.771,0,0,1-4.748,1.838Z",
    transform: "translate(-2064.89 -3009.15)",
    fill: "#f64f64"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment_failed.ad86480d93f300e4ea3b2a9410092906.svg";
export { ForwardRef as ReactComponent };